<template>
    <svg
        version="1.1"
        id="katman_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 841.89 595.28"
        style="enable-background: new 0 0 841.89 595.28"
        xml:space="preserve"
    >
        <g>
            <g>
                <path
                    class="st0"
                    d="M171.49,332.08c-1.69,0.94-2.82,1.5-6.51,2.1l-27.16,4.42l-14.43,22.84l-3.25-19.97l-18.42,3
			c-12.62,2.05-24.55-6.54-26.61-19.16l-10.29-63.26c-2.05-12.62,6.54-24.55,19.16-26.61l63.26-10.29c9.21-1.5,14.9,0.34,19.63,6.33
			l3.16,3.99l2.88-11.53l-0.76-0.96c-8.08-10.21-15.76-9.83-26.57-8.07L82.32,225.2c-18.27,2.97-30.71,20.25-27.74,38.52
			l10.29,63.26c1.44,8.84,6.24,16.59,13.52,21.83c7.28,5.25,16.16,7.34,24.99,5.9l8.18-1.33l5.98,36.74l26.56-42.03l22.54-3.67
			c5.09-0.83,7.53-1.65,11.98-4.92l2.76-2.03l-8.51-6.17L171.49,332.08z"
                />
                <path
                    class="st0"
                    d="M281.57,217l-63.08-11.31c-18.22-3.26-35.69,8.9-38.96,27.11l-11.31,63.08c-3.27,18.22,8.9,35.69,27.11,38.96
			l8.16,1.46l-6.57,36.64l39.01-30.82l22.48,4.03c1.96,0.35,3.96,0.53,5.93,0.53c0,0,0.01,0,0.01,0c16.26,0,30.15-11.63,33.02-27.64
			l11.31-63.08C311.95,237.74,299.78,220.27,281.57,217z M298.46,254.13l-11.31,63.08c-1.98,11.07-11.57,19.1-22.81,19.1
			c0,0,0,0,0,0c-1.37,0-2.75-0.12-4.1-0.37l-27.08-4.86l-21.2,16.75l3.57-19.91l-18.37-3.29c-12.58-2.26-20.98-14.33-18.73-26.91
			l11.31-63.08c1.98-11.06,11.58-19.1,22.81-19.1c1.37,0,2.75,0.12,4.1,0.37l63.08,11.31C292.32,229.47,300.72,241.54,298.46,254.13
			z"
                />
                <path
                    class="st0"
                    d="M128.66,313.26c-7.03,1.1-14.06-0.61-19.8-4.8c-5.74-4.19-9.51-10.37-10.61-17.4l-0.39-2.47l-10.25,1.6
			l0.39,2.47c1.52,9.77,6.76,18.35,14.74,24.18c6.38,4.66,13.9,7.12,21.74,7.12c1.92,0,3.87-0.15,5.78-0.45
			c9.76-1.52,18.35-6.76,24.18-14.74c5.83-7.98,8.2-17.76,6.67-27.52l-0.39-2.47l-10.25,1.6l0.39,2.47c1.1,7.03-0.61,14.06-4.8,19.8
			C141.86,308.4,135.69,312.17,128.66,313.26z"
                />
                <path
                    class="st0"
                    d="M264.62,282.49c-1.33,6.97-5.31,13.02-11.2,17.02c-5.89,4-12.98,5.47-19.95,4.14h0
			c-6.98-1.33-13.03-5.31-17.03-11.19c-4-5.88-5.46-12.97-4.12-19.96l0.47-2.46l-10.19-1.95l-0.47,2.46
			c-1.86,9.71,0.18,19.56,5.73,27.73c5.55,8.18,13.96,13.7,23.66,15.56c2.3,0.44,4.64,0.66,6.96,0.66c17.72,0,33-12.64,36.33-30.06
			l0.47-2.46l-10.19-1.95L264.62,282.49z"
                />
            </g>
            <g>
                <path
                    class="st1"
                    d="M352.46,316.29c4.08,4.3,8.77,7.72,14.07,10.26c5.3,2.54,10.87,3.81,16.72,3.81
			c7.5-0.11,13.51-1.52,18.04-4.22c4.52-2.7,6.79-6.48,6.79-11.34c0-2.32-0.66-4.27-1.99-5.88c-1.32-1.6-3.14-2.84-5.46-3.72
			c-2.32-0.88-4.91-1.57-7.78-2.07c-2.87-0.5-6.46-1.08-10.76-1.74c-6.73-0.88-12.14-1.76-16.22-2.65
			c-4.08-0.88-8.06-2.32-11.92-4.3c-3.86-1.99-6.98-4.85-9.35-8.61c-2.37-3.75-3.56-8.5-3.56-14.23c0-4.52,1.1-8.72,3.31-12.58
			c2.21-3.86,5.3-7.2,9.27-10.01s8.58-4.97,13.82-6.46c5.24-1.49,10.78-2.23,16.63-2.23c17.21,0,31,5.3,41.38,15.89l-14.23,12.74
			c-4.53-4.52-9.05-7.72-13.57-9.6c-4.53-1.88-9.38-2.81-14.56-2.81c-7.28,0-12.74,1.44-16.39,4.3c-3.64,2.87-5.46,6.12-5.46,9.77
			c0,2.32,0.66,4.25,1.99,5.79c1.32,1.55,3.12,2.76,5.38,3.64c2.26,0.88,4.77,1.57,7.53,2.07c2.76,0.5,6.46,1.02,11.09,1.57
			c6.29,0.88,11.59,1.77,15.89,2.65c4.3,0.88,8.38,2.32,12.25,4.3c3.86,1.99,6.98,4.88,9.35,8.69c2.37,3.81,3.56,8.64,3.56,14.48
			c0,5.3-1.24,10.1-3.72,14.4c-2.48,4.3-5.88,7.97-10.18,11.01c-4.3,3.04-9.21,5.35-14.73,6.95c-5.52,1.6-11.25,2.4-17.21,2.4
			c-7.84,0-15.67-1.57-23.5-4.72c-7.84-3.14-14.84-7.97-21.02-14.48L352.46,316.29z"
                />
                <path
                    class="st1"
                    d="M439.18,266.3h17.21v44.85c0,5.85,1.88,10.68,5.63,14.48c3.75,3.81,8.33,5.71,13.74,5.71
			c5.4,0,9.98-1.9,13.74-5.71c3.75-3.81,5.63-8.63,5.63-14.48V266.3h17.21v46.34c0,5.41-0.99,10.34-2.98,14.81
			c-1.99,4.47-4.69,8.28-8.11,11.42c-3.42,3.14-7.34,5.54-11.75,7.2c-4.41,1.66-8.99,2.48-13.74,2.48c-4.75,0-9.33-0.83-13.74-2.48
			c-4.41-1.66-8.33-4.06-11.75-7.2c-3.42-3.14-6.12-6.95-8.11-11.42c-1.99-4.47-2.98-9.41-2.98-14.81V266.3z"
                />
                <path
                    class="st1"
                    d="M544.78,276.07h0.33c3.09-3.86,6.89-6.81,11.42-8.85c4.52-2.04,9.49-3.06,14.9-3.06
			c6.29,0,12.02,1.19,17.21,3.56c5.19,2.37,9.6,5.57,13.24,9.6c3.64,4.03,6.4,8.58,8.28,13.65c1.88,5.08,2.81,10.21,2.81,15.39
			c0,4.97-0.99,9.96-2.98,14.98c-1.99,5.02-4.86,9.6-8.61,13.74c-3.75,4.14-8.25,7.42-13.49,9.85c-5.24,2.43-11.01,3.64-17.3,3.64
			c-5.74,0-10.84-1.1-15.31-3.31s-7.86-5.07-10.18-8.61h-0.33v37.41h-17.21V266.3h17.21V276.07z M592.78,296.34
			c-1.32-3.14-3.17-5.93-5.54-8.36c-2.37-2.43-5.1-4.3-8.19-5.63c-3.09-1.32-6.35-1.99-9.77-1.99c-3.31,0-6.48,0.66-9.52,1.99
			c-3.04,1.32-5.74,3.2-8.11,5.63c-2.37,2.43-4.22,5.21-5.54,8.36s-1.99,6.48-1.99,10.01c0,3.53,0.66,6.87,1.99,10.01
			c1.32,3.14,3.17,5.93,5.54,8.36c2.37,2.43,5.07,4.3,8.11,5.63c3.03,1.32,6.21,1.99,9.52,1.99c3.42,0,6.67-0.66,9.77-1.99
			c3.09-1.32,5.82-3.2,8.19-5.63c2.37-2.43,4.22-5.21,5.54-8.36c1.32-3.15,1.99-6.48,1.99-10.01
			C594.76,302.83,594.1,299.49,592.78,296.34z"
                />
                <path
                    class="st1"
                    d="M626.37,322.58c3.2,3.42,7.12,6.23,11.75,8.44c4.63,2.21,9.1,3.31,13.41,3.31c4.63,0,8.44-1.08,11.42-3.23
			c2.98-2.15,4.47-4.44,4.47-6.87c0-2.54-0.91-4.58-2.73-6.12c-1.82-1.54-4.39-2.59-7.7-3.14l-9.77-1.82
			c-10.81-1.99-18.32-4.77-22.51-8.36c-4.19-3.58-6.29-8.41-6.29-14.48c0-7.17,2.84-13.32,8.52-18.45c5.68-5.13,13.32-7.7,22.92-7.7
			c5.63,0,10.98,0.88,16.05,2.65c5.07,1.77,10.32,4.58,15.72,8.44l-9.77,12.08c-3.86-3.31-7.61-5.63-11.25-6.95
			c-3.64-1.32-7.06-1.99-10.26-1.99c-3.97,0-7.42,0.91-10.34,2.73c-2.92,1.82-4.39,4.28-4.39,7.37c0,4.41,3.48,7.23,10.43,8.44
			l17.38,3.31c14.12,2.65,21.19,9.77,21.19,21.35c0,3.09-0.66,6.21-1.99,9.35c-1.32,3.14-3.37,6.07-6.12,8.77
			c-2.76,2.71-6.32,4.86-10.68,6.46c-4.36,1.6-9.41,2.4-15.14,2.4c-13.02,0-25.05-4.69-36.08-14.07L626.37,322.58z"
                />
                <path
                    class="st1"
                    d="M694.4,243.13c1.88-1.88,4.14-2.81,6.79-2.81c2.65,0,4.91,0.94,6.79,2.81c1.88,1.88,2.81,4.14,2.81,6.79
			c0,2.65-0.94,4.91-2.81,6.79c-1.88,1.88-4.14,2.81-6.79,2.81c-2.65,0-4.91-0.94-6.79-2.81c-1.88-1.88-2.81-4.14-2.81-6.79
			C691.59,247.27,692.52,245.01,694.4,243.13z M692.58,266.3h17.21v80.11h-17.21V266.3z"
                />
                <path
                    class="st1"
                    d="M729.49,322.58c3.2,3.42,7.12,6.23,11.75,8.44c4.63,2.21,9.1,3.31,13.41,3.31c4.63,0,8.44-1.08,11.42-3.23
			c2.98-2.15,4.47-4.44,4.47-6.87c0-2.54-0.91-4.58-2.73-6.12c-1.82-1.54-4.39-2.59-7.7-3.14l-9.77-1.82
			c-10.81-1.99-18.32-4.77-22.51-8.36c-4.19-3.58-6.29-8.41-6.29-14.48c0-7.17,2.84-13.32,8.52-18.45c5.68-5.13,13.32-7.7,22.92-7.7
			c5.63,0,10.98,0.88,16.05,2.65c5.07,1.77,10.32,4.58,15.72,8.44L775,287.32c-3.86-3.31-7.61-5.63-11.25-6.95
			c-3.64-1.32-7.06-1.99-10.26-1.99c-3.97,0-7.42,0.91-10.34,2.73c-2.92,1.82-4.39,4.28-4.39,7.37c0,4.41,3.48,7.23,10.43,8.44
			l17.38,3.31c14.12,2.65,21.19,9.77,21.19,21.35c0,3.09-0.66,6.21-1.99,9.35c-1.32,3.14-3.37,6.07-6.12,8.77
			c-2.76,2.71-6.32,4.86-10.68,6.46c-4.36,1.6-9.41,2.4-15.14,2.4c-13.02,0-25.05-4.69-36.08-14.07L729.49,322.58z"
                />
            </g>
        </g>
    </svg>
</template>
<script>
export default {
    name: "SupsisLogoPurple",
};
</script>
<style lang="scss" scoped>
.st0 {
    fill: #fe6244;
}

.st1 {
    fill: #5022d1;
}
</style>
